import { createComponent } from '@ycos/fela'

const PictureHoverState = createComponent('PictureHoverState', ({ theme }) => {
  return {
    width: '100%',
    height: '100%',
    backgroundColor: theme.typography.colors.PrimaryWhite,
    opacity: 0,
    position: 'absolute',
    zIndex: 2,
    transition: `opacity ${theme.motionSpecs.motionDurations.t3}ms ${theme.motionSpecs.motionGraphs.ease}`,
    ':hover': {
      opacity: '0.3'
    }
  }
})

const ImageContentWrapper = createComponent('ImageContentWrapper', () => {
  return {
    width: '100%',
    position: 'relative'
  }
})

const ImageHolder = createComponent('ProductCardImageHolder', ({ theme }) => {
  return {
    display: 'block',
    width: '100%',
    height: '100%',
    background: theme.typography.colors.PrimaryGrey,
    position: 'absolute',
    top: '0'
  }
})

export { PictureHoverState, ImageContentWrapper, ImageHolder }
